import { SystemField } from "./system-field";

export class PurchaseOrder extends SystemField {
    
    status?:string;
    total_qty?:number;
    total_cost?:number;
    po_date?:string;
    promised_date?:string;
    vendor_id?:string;
    total_discount?:number;
    vat_exempt_total?:number;
    vat_taxable_total?:number;
    tax_total?:number;
    po_num?:string;
    po_type?:string;
    purchase_by_id?:string;
}
export class PurchaseOrderTranslation extends SystemField{
     
     description?:string;
     purchase_orders_id?:string;
     lang_code?:string;
}
